import Vue from 'vue'
import Vuex from 'vuex'

import common from './modules/common'
import headNav from './modules/headNav'
import materialsBill from './modules/materialsBill'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: { common, headNav, materialsBill },
    strict: debug
})


// WEBPACK FOOTER //
// ./src/store/index.js